import { LanguageCode } from '../../i18n/languages';

export interface IdName {
    id: string;
    name: string;
}

export interface CodeTitle {
    code: string;
    title: string;
}

export type CurrencyCode = 'RUB' | 'RSD';
export const currencyCodes: CurrencyCode[] = ['RSD', 'RUB'];
export const currencyDefaultCode: CurrencyCode = 'RSD';

export type WithLang<T = {}> = T & { lang: LanguageCode };
